@if (caseDetails$ | async; as details) {
@if (details?.caseFlow){
<!-- Case Status Card -->
<div class="p-2 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 mb-4">
  <h3 (click)="toggle()" [class.cursor-pointer]="!isMobile" class="text-base text-gray-800 dark:text-gray-200 mb-2 flex items-center justify-between gap-1" data-cy="page-caseDetails-div-caseStatusHeader">
    <div class="flex items-center gap-1">
      <span class="material-symbols-outlined text-sm">info</span>
      <span>Case Status</span>
    </div>
    @if (!isMobile) {
    <span class="material-symbols-outlined transition-transform duration-300" [class.rotate-180]="isExpanded" data-cy="page-caseDetails-button-toggleStatus">
      expand_more
    </span>
    }
  </h3>
  <div [@collapseAnimation]="isExpanded ? 'expanded' : 'collapsed'">
    @if (filteredActionItems$ | async; as items) {
    <ul class="space-y-1 pt-2 border-t border-gray-200 dark:border-gray-700">
      @for (item of items; track $index) {
      <li
        data-cy="page-caseDetails-list-statusItem"
        class="group text-xs text-gray-900 dark:text-gray-100 flex items-center gap-1 p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 cursor-default">
        <span class="material-symbols-outlined text-sm" [ngClass]="item.completedOn ? 'text-green-500' : 'text-red-500'">
          {{ item.completedOn ? 'check_circle' : 'pending_actions' }}
        </span>
        <div class="flex flex-col">
          <span class="break-words" data-cy="page-caseDetails-text-statusName">{{ item.name }}</span>
          @if(item.completedOn) {
          <span class="text-xs text-gray-500 dark:text-gray-400" data-cy="page-caseDetails-text-statusDate">{{ item.completedOn | date : 'shortDate' }}</span>
          }
        </div>
      </li>
      }
    </ul>
    } @else {
    <p class="text-xs text-gray-500 dark:text-gray-400 p-1">No case status items.</p>
    }
  </div>
</div>
}
}